import {getErrorMessage, setRequiredLabel} from '@/utils/helpers';
import {Field, Form, Formik} from 'formik';
import {useMemo, FC, FocusEvent} from 'react';
import {ProfileGeneralForm} from '../ProfileForm/ProfileGeneralForm.style';
import {Box, Typography} from '@mui/material';
import {FIELD, FIELD_LABEL, H5, PLACEHOLDER} from '@/utils/constants';
import Input from '@/shared/components/Inputs/Input';
import {defaultInitialValues, validationSchema} from './formConfiguration';
import {ITeam} from '@/utils/types';
import {toast} from 'react-toastify';
import {ITeamRole} from '@/utils/enums';
import { OrganizationTeamService } from '@/utils/services';

interface IFormProps {
  team: ITeam;
}

const ProfileTeamMemberGeneral: FC<IFormProps> = ({team}) => {

  const formikInitialValues = useMemo(() => {
    const initialValues = team
      ? {
          firstName: team.firstName,
          lastName: team.lastName,
          email: team.email,
          role: team.role === ITeamRole.STANDART ? ITeamRole.MEMBER : team.role,
        }
      : null;
    return initialValues || defaultInitialValues;
  }, [team]);

  const updateProfile = async (event: FocusEvent<HTMLInputElement>, param: string) => {
    const REQUIRED_FIELDS = [FIELD.firstName, FIELD.lastName, FIELD.email];
    const newValue = event.target.value.trim();

    if (REQUIRED_FIELDS.includes(param) && !newValue) return;

    const {id, firstName, lastName, email, logo} = team;

    const params = {
      id,
      firstName,
      lastName,
      email,
      [param]: newValue,
      logo: logo?.split('/')[4]?.split('?')[0] || '',
    };

    try {
      if (team[param as keyof ITeam] === newValue) return;

    await OrganizationTeamService.updateTeamMember(team.id as number, params);
    } catch (error) {
      toast.error(getErrorMessage(error));
    }
  };

  return (
    <Formik
      initialValues={formikInitialValues}
      validationSchema={validationSchema()}
      onSubmit={() => {}}
      enableReinitialize={true}
    >
      <Box sx={ProfileGeneralForm.widget}>
        <Form style={{width: '100%'}}>
          <Box sx={{width: '100%'}}>
            <Typography variant={H5} sx={[ProfileGeneralForm.formTitle, ProfileGeneralForm.widgetTitle]}>
              Contact Information
            </Typography>
            <Box sx={ProfileGeneralForm.formContainer}>
              <Box sx={ProfileGeneralForm.fieldContainer}>
                <Box sx={ProfileGeneralForm.field}>
                  <Field
                    id={FIELD.firstName}
                    name={FIELD.firstName}
                    placeholder={PLACEHOLDER.firstName}
                    label={setRequiredLabel(FIELD_LABEL.firstName)}
                    component={Input}
                    onBlur={(event: FocusEvent<HTMLInputElement>) => updateProfile(event, FIELD.firstName)}
                  />
                </Box>
                <Box sx={ProfileGeneralForm.field}>
                  <Field
                    id={FIELD.lastName}
                    name={FIELD.lastName}
                    placeholder={PLACEHOLDER.lastName}
                    label={setRequiredLabel(FIELD_LABEL.lastName)}
                    component={Input}
                    onBlur={(event: FocusEvent<HTMLInputElement>) => updateProfile(event, FIELD.lastName)}
                  />
                </Box>
              </Box>
              <Box sx={ProfileGeneralForm.fieldContainer}>
                <Box sx={ProfileGeneralForm.field}>
                  <Field
                    id={FIELD.email}
                    name={FIELD.email}
                    placeholder={PLACEHOLDER.email}
                    label={setRequiredLabel(FIELD_LABEL.email)}
                    component={Input}
                    onBlur={(event: FocusEvent<HTMLInputElement>) => updateProfile(event, FIELD.email)}
                  />
                </Box>
                <Box sx={ProfileGeneralForm.field}>
                  <Field
                    id={FIELD.role}
                    name={FIELD.role}
                    label={setRequiredLabel(FIELD_LABEL.role)}
                    component={Input}
                    disabled
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        </Form>
      </Box>
    </Formik>
  );
};

export default ProfileTeamMemberGeneral;
